import { fetchReport, buildExcelFromGenericRows } from './utils';
import {
  GenericReportRow,
  DownloadResults,
  DownloadExamsOptions
} from '../types/MarksAnalyticsTypes';

const downloadMultipleExamReports = async ({
  school,
  academicYear,
  grade,
  division,
  examsOptions,
  selectedExamIds
}: DownloadExamsOptions): Promise<DownloadResults> => {
  let successCount = 0;
  let emptyCount = 0;
  let notReadyCount = 0;
  let failureCount = 0;

  for (const examId of selectedExamIds) {
    try {
      const response: any = await fetchReport({
        school,
        academicYear,
        grade,
        division,
        examIds: [examId],
        isDetailedReport: false
      });

      const rows = Array.isArray(response) ? response : response?.data || [];
      if (!rows.length) {
        emptyCount++;
        continue;
      }

      const examLabel =
        examsOptions.find((e) => e.id === examId)?.name || examId;
      const fileName =
        (response?.fileName as string | undefined) ||
        `${school}-MarksAnalytics-${grade}-${division}-${academicYear}-${examLabel}`;

      buildExcelFromGenericRows(rows as GenericReportRow[], {
        school,
        grade,
        division,
        academicYear,
        preferredFileName: fileName
      });

      successCount++;
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 404) {
        notReadyCount++;
      } else {
        failureCount++;
      }
    }
  }

  return { successCount, emptyCount, notReadyCount, failureCount };
};

export { downloadMultipleExamReports };
